import { transform, isEqual, isObject } from "lodash/fp"

// object diff
const _transform = transform.convert({
	cap: false
})

const iteratee = baseObj => (result, value, key) => {
	if (!isEqual(value, baseObj[key])) result[key] = value
}

const diff_obj = (targetObj, baseObj) => {
	return _transform(iteratee(baseObj), null, targetObj)
}

export { diff_obj }